import { render, staticRenderFns } from "./MetodoPago.vue?vue&type=template&id=29051492&lang=pug"
import script from "./MetodoPago.vue?vue&type=script&lang=js"
export * from "./MetodoPago.vue?vue&type=script&lang=js"
import style0 from "./MetodoPago.vue?vue&type=style&index=0&id=29051492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports